import React, { useState, useEffect } from "react";
import { Typography, Button, Switch, makeStyles, FormControl, Grid, withStyles } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Check } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  formTitle: {
    marginBottom: theme.spacing(4),
    fontWeight: 700,
    fontSize: 32,
    position: 'relative',
  },
  optionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(4),
  },
  optionLabel: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 2,
  },
  optionDesc: {
    fontWeight: 400,
    fontSize: 16,
    color: '#222',
    marginBottom: 0,
  },
  button: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
  },
  backButton: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
    background: '#707070',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
  iosSwitch: {
    '& > *': {
      height: '22px !important',
    },
    '& .MuiSwitch-switchBase .MuiSwitch-track': {
      backgroundColor: '#c6c6c6 !important',
    },
    '& .MuiSwitch-switchBase': {
      left: '2px',
      top: '-1px',
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      left: 'auto',
      right: '18px',
    },
    '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-track': {
      backgroundColor: '#1890ff !important',
    },
  },
  checkedSwitch: {
    position: 'absolute',
    width: '16px !important',
    left: '12px',
    top: '7px',
    color: 'white',
  }
}));

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 44,
    height: 22,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "& .MuiSwitch-track": {
      backgroundColor: "#c6c6c6 !important",
    },
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#1890ff !important",
        opacity: 1,
        border: "none",
      },
      "& .MuiSwitch-track": {
        backgroundColor: "#1890ff !important",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 18,
    height: 18,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "#c6c6c6",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    disabled={props.disabled}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));



const OptionsPermissions = ({ updateStepData, handleNext, handleBack, formData, readOnly = false }) => {
  const classes = useStyles();
  const defaultOptions = {
    twoStep: false,
    cannotEditPhone: false,
    azureAd: false,
    ...formData
  };
  const [stepData, setStepData] = useState(defaultOptions);



  useEffect(() => {
    setStepData({
      twoStep: false,
      cannotEditPhone: false,
      azureAd: false,
      ...formData
    });
  }, [formData, readOnly]);

  const handleFieldChange = (e) => {
    const { name, value, checked, type } = e.target;
    const updatedValue = type === 'checkbox' ? checked : value;
    setStepData(prev => ({ ...prev, [name]: updatedValue }));
    if (typeof updateStepData === 'function') {
      updateStepData({ ...stepData, [name]: updatedValue });
    }
  };

  const handleNextClick = () => {
    
    updateStepData(stepData);
    handleNext();
  };


  return (
    <div className="cmo-stepper-wrapper">
      <div className="stepper-container">
        <form>
          <Typography variant="h6" className={classes.formTitle}>
            Options And Permissions (Default)
          </Typography>
          <div className={classes.optionRow}>
            <div>
              <div className={classes.optionLabel}>Should be 2-step authenticated</div>
              <div className={classes.optionDesc}>Authenticate the person using code sent to the persons device (phone number in this case).</div>
            </div>
            <span style={{ position: 'relative' }}>
              <IOSSwitch
                checked={stepData.twoStep}
                onChange={handleFieldChange}
                name="twoStep"
                color="primary"
                disabled={readOnly}
                className={classes.iosSwitch}
              />
              {stepData.twoStep && <Check className={classes.checkedSwitch} />}
            </span>
          </div>
          <div className={classes.optionRow}>
            <div>
              <div className={classes.optionLabel}>Cannot edit phone number</div>
              <div className={classes.optionDesc}>Don't allow the user to edit their phone number. This requires you to enter the phone number.</div>
            </div>
            <span style={{ position: 'relative' }}>
              <IOSSwitch
                checked={stepData.cannotEditPhone}
                onChange={handleFieldChange}
                name="cannotEditPhone"
                color="primary"
                disabled={readOnly}
                className={classes.iosSwitch}
              />
              {stepData.cannotEditPhone && <Check className={classes.checkedSwitch} />}
            </span>
          </div>
          {/* {localStorage.getItem('collabType') !== 'CMO' && <div className={classes.optionRow}>
            <div>
              <div className={classes.optionLabel}>Use Ping sign-in</div>
              <div className={classes.optionDesc}>Enable this option to use Ping credentials to verify the person.</div>
            </div>
            <span style={{ position: 'relative' }}>
              <IOSSwitch
                checked={stepData.azureAd}
                onChange={handleFieldChange}
                name="azureAd"
                color="primary"
                disabled={readOnly}
                className={classes.iosSwitch}
              />
              {stepData.azureAd && <Check className={classes.checkedSwitch} />}
            </span>
          </div>} */}
          {!readOnly && <div className="stepper-navigation-btns" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
            <Button variant="outlined" startIcon={<ArrowBackIosIcon />} color="default" onClick={handleBack} className={classes.backButton}>
              Back
            </Button>
            <Button variant="contained" color="primary" onClick={handleNextClick} className={classes.button} endIcon={<ArrowForwardIosIcon />}>
              Save & Next
            </Button>
          </div>}
        </form>
      </div>
    </div>
  );
};

export default OptionsPermissions; 